import React from "react";
import ModalItem from "./ModalItem";
import ButtonItem from "./ButtonItem";

function ModalNotificacionesOrdenPU({ visible, notificaciones, onClose, onMarcarLeida, onVer }) {
  const titulo =
    notificaciones.length > 1
      ? `Notificaciones de Órdenes de Producción (${notificaciones.length})`
      : "Notificación de Órdenes de Producción";

  return (
    <ModalItem title={titulo} visible={visible} onCancel={onClose} width={480} footer={null}>
      <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
        {notificaciones.map((n) => (
          <div
            key={n.id}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
              padding: "10px 12px",
              marginBottom: 8,
              background: "#f6ffed",
              border: "1px solid #b7eb8f",
              borderRadius: 8,
            }}
          >
            <div style={{ fontSize: 18, marginTop: 2, color: "#389e0d" }}>{n.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600 }}>{n.title}</div>
              <div style={{ whiteSpace: "pre-line", color: "rgba(0,0,0,0.65)" }}>{n.message}</div>
              <div style={{ fontSize: 12, color: "rgba(0,0,0,0.45)", marginTop: 4 }}>{n.fecha}</div>
              <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                {n.ruta && (
                  <ButtonItem cyan lessTime onClick={() => onVer(n.id, n.ruta, n.estadoRuta)}>
                    Ver
                  </ButtonItem>
                )}
                <ButtonItem verdeNatural lessTime onClick={() => onMarcarLeida(n.id)}>
                  Marcar leído
                </ButtonItem>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
        <ButtonItem danger onClick={onClose}>
          Cerrar
        </ButtonItem>
      </div>
    </ModalItem>
  );
}

export default ModalNotificacionesOrdenPU;
